/**
 * Node class created from subscriptions list and used for angular-tree display
 */
export class Node {
  name: string;
  groupId: number;
  contractId: number;
  planId: number;
  status: string;
  children: Node[];
}



// WEBPACK FOOTER //
// ./src/app/models/node.ts